import logger from "../logging/Logger.js";
import { decodeBase64 } from "./decodeBase64.js";
const parseIdToken = (idToken) => {
  try {
    const separatedToken = idToken.split(".");
    if (separatedToken.length === 3) {
      const payload = separatedToken[1].replace(/-/g, "+").replace(/_/g, "/");
      const decodePayload = decodeBase64(payload);
      return JSON.parse(decodePayload);
    } else {
      return void 0;
    }
  } catch (e) {
    logger.log("JWT token format is invalid");
    return void 0;
  }
};
export {
  parseIdToken
};
//# sourceMappingURL=parseIdToken.js.map
